import {
  Avatar,
  Box,
  Flex,
  Image
} from "@chakra-ui/react";
import { useRef, useState } from "react";
import { useAppDispatch } from "@/store/hooks";
import { MsUser } from "@/types/msuser";
type Props = {
  sessionContent: MsUser;
  isLast?: boolean;
};

const OtherSessionItem = (props: Props) => {
  const { sessionContent,  isLast } = props;

  const isBase64Image = (str:string) =>{
    const regex = /^data:image\/(\w+);base64,/;
    return regex.test(str);
  }


  return (
    <Flex alignItems="flex-start" mb="30px">
      <Avatar
        mr="14px"
        w="40px"
        h="40px"
        name="ALDGPT"
        // borderRadius={"2px"}
        src={`/api/v4/users/${sessionContent.from_user.id}/image`}
      />
      <Box maxW={"70%"}>
        <Box
          bgColor={"#DCE0EB"}
          p="10px"
          borderRadius={"5px"}
          boxSizing="border-box"
          color={"#27314D"}
          fontSize="14px"
        >
          {!isBase64Image(sessionContent.content) && sessionContent.content}
          {isBase64Image(sessionContent.content) && <Image boxSize={"200px"} src={sessionContent.content} />}
        </Box>
      </Box>
      
    </Flex>
  );
};

export default OtherSessionItem;
